export const FASTTRACK_BRAND = import.meta.env.VITE_FASTTRACK_BRAND || 'sweepluxe';
export const FASTTRACK_SOURCE = import.meta.env.VITE_FASTTRACK_SOURCE || 'sweepluxe';
export const FASTTRACK_STAGING = import.meta.env.VITE_FASTTRACK_STAGING === 'true';
export const FASTTRACK_REWARDS_ENABLE = import.meta.env.VITE_FASTTRACK_REWARDS_ENABLE === 'true';
export const FASTTRACK_INTEGRATION_VERSION = parseFloat(import.meta.env.VITE_FASTTRACK_INTEGRATION_VERSION || 1.1);
export const FASTTRACK_SCRIPT_URL = import.meta.env.VITE_FASTTRACK_SCRIPT_URL || 'https://crm-lib-staging.fasttrack-solutions.com/loader/fasttrack-crm.js';
